// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Style__blockquote--hhJet {
    border-left: .25em solid #3d444d;
    margin-left: 0;
    padding: 0.5rem 1rem;
}

.Style__title--ciDPN {
    margin-bottom: 1rem;
    display: flex;
}

.Style__titleContent--lqDIj {
    margin-left: 0.5rem;
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/Components/WrapMarkdown/GithubQuote/Style.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB","sourcesContent":[".blockquote {\r\n    border-left: .25em solid #3d444d;\r\n    margin-left: 0;\r\n    padding: 0.5rem 1rem;\r\n}\r\n\r\n.title {\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n}\r\n\r\n.titleContent {\r\n    margin-left: 0.5rem;\r\n    font-weight: bold;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blockquote": `Style__blockquote--hhJet`,
	"title": `Style__title--ciDPN`,
	"titleContent": `Style__titleContent--lqDIj`
};
export default ___CSS_LOADER_EXPORT___;
